import React, { useState, useMemo, useContext, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { FileIcon, defaultStyles } from "react-file-icon";
import useEntitesTable from "./useEntitesTable.js";
import CustomDeleteDialog from "../CustomDeleteDialog/CustomDeleteDialog.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import CustomCommentDialog from "../CustomCommentDialog/CustomCommentDialog.js";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import UserService from "../../services/UserService";
import { NotificationManager } from "react-notifications";
//import "react-table/react-table.css";

// @mui/icons-material
import GetAppIcon from "@mui/icons-material/GetApp";

import Button from "components/CustomButtons/Button.js";

import { downloadFile, getFiles, postComment, deleteFiles } from "services/ConfigServices";

const useStyles = makeStyles(styles);

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const RTDocuments = () => {
  const appContext = useContext(AdvancedSearchContext);
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const user_admin = permis.includes("ged_update");
  const { setPage } = appContext;
  const { gridState, refetch } = useEntitesTable();
  const [commentaire, setCommentaire] = useState("");

  let allData = gridState;

  let dataDocuments = allData.data;

  const classes = useStyles();

  const convertToKB = (value) => value / Math.pow(1024, 1);

  useEffect(() => {
    setPage('documents');
  }, []);


  const columns = [
    {
      name: "",
      selector: (row) => row.fileType,
      sortable: true,
      width: "4rem",
      cell: (row) => (
        <div style={{ width: "30px" }}>
          <FileIcon extension={row.fileType} {...defaultStyles[row.fileType]} />
        </div>
      ),
    },
    {
      name: "Nom",
      selector: (row) => row.fileName,
      sortable: true,
      wrap: true,
      grow: 0.75,
    },
    {
      name: "Propriétaire",
      selector: (row) => row.ownerName,
      sortable: true,
      maxWidth: "10rem",
      wrap: true,
    },
    {
      name: "Groupe",
      selector: (row) => row.groupName,
      sortable: true,
      width: "8rem",
      wrap: true,
    },
    {
      name: "Date",
      selector: (row) => row.importDate,
      sortable: true,
      width: "10rem",
      cell: (row) => moment(Number(row.importDate)).format("DD/MM/YYYY HH:mm"),
    },
    {
      name: "Taille (Ko)",
      selector: (row) => row.fileSize,
      sortable: true,
      width: "5rem",
      right: true,
      cell: (row) => convertToKB(row.fileSize).toFixed(2),
    },
    {
      name: "Commentaire",
      selector: (row) => row.comments,
      sortable: false,
      grow: 1,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <CustomCommentDialog
              comment={row.comments}
              handleNewComment={handleNewComment}
              handleSendComment={CommentGED(row)}
            />
          </div>
        </>
      ),
    },
    {
      name: "Actions",
      sortable: false,
      width: "8rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              onClick={downloadGED(row)}
              color={"info"}
              className={classes.actionButton}
            >
              <GetAppIcon fontSize="large" />
            </Button>{" "}
            {
              user_admin ? <CustomDeleteButton
                deleteTitle={"Suppression du document"}
                deleteSubTitle={
                  "Êtes-vous sûr de vouloir supprimer le document ?"
                }
                handleSupprimer={deleteGED(row)}
              /> : <></>
            }

          </div>
        </>
      ),
    },
  ];

  const downloadGED = (row) => async () => {
    let obj = dataDocuments.find((o) => o.fileId === row.fileId);
    let idSelected = obj.fileId;
    let fileNameSelected = obj.fileName;
    axios
      .get(downloadFile(idSelected), {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileNameSelected); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const deleteGED = (row) => async () => {
    let obj = dataDocuments.find((o) => o.fileId === row.fileId);
    let idSelected = obj.fileId;
    axios
      .delete(deleteFiles(idSelected), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success("Le document a bien été supprimé");
        else NotificationManager.error("Un problème est survenu");
        refetch();
      });
  };

  const handleNewComment = (event) => {
    setCommentaire(event.target.value);
  };

  const CommentGED = (row) => async () => {
    let obj = dataDocuments.find((o) => o.fileId === row.fileId);
    let idSelected = obj.fileId;
    axios
      .post(
        postComment(idSelected),
        { comment: commentaire },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        refetch();
      });
  };
  return (
    <>
      <div style={{ paddingTop: 10 }}>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun document à afficher</NoData>}
          noHeader={true}
          columns={columns}
          persistTableHead
          pagination
          subHeader
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Lignes par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les lignes",
          }}
          progressPending={allData.loading}
          progressComponent={<LinearProgress />}
          {...allData}
        />
      </div>
    </>
  );
};

export default RTDocuments;
